module.exports = __webpack_public_path__ + "static/img/3-2-5.8b9bbc6d.jpg";